var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"button",class:{
    'is-small': _vm.isSmall,
    'is-medium': _vm.isMedium,
    'is-nb-iot': _vm.isNbIot,
    'with-outline': _vm.withOutline,
    'has-padding': _vm.hasPadding || _vm.withOutline,
    'is-disabled': _vm.disabled,
    'is-light': _vm.isLight,
  },attrs:{"color":_vm.isWarning ? 'warning' : 'primary',"loading":_vm.isLoading,"disabled":_vm.disabled,"to":_vm.to,"depressed":"","text":_vm.isText,"height":_vm.height},on:{"click":_vm.clickCallback}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }